import { ReactNode } from "react";

import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type StepperHeaderProps = {
  children: ReactNode;
};

const StepperHeader = ({ children }: StepperHeaderProps) => {
  return (
    <Typography tag="h2" color="secondary" transform="uppercase" className={styles.stepperHeader}>
      {children}
    </Typography>
  );
};

StepperHeader.displayName = "DS.Stepper.Header";

export default StepperHeader;
